export default __webpack_public_path__ + "static/media/Illustration2.eebd3460.png";